import {
	Grid,
	Typography,
	checkboxClasses,
	Checkbox,
	ListItemText,
	ListItemIcon,
	Paper,
	ListItem,
	List,
	Tooltip,
} from '@mui/material';

import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { ReactComponent as DeleteTestScriptModalIcon } from 'common/assets/images/delete-outline.svg';
import { ReactComponent as EditIcon } from 'common/assets/images/edit-Icon.svg';
import { ReactComponent as EditTestScriptModalIcon } from 'common/assets/images/edit-survey-outline.svg';
import { ReactComponent as OrderIcon } from 'common/assets/images/order-icon.svg';
import { ReactComponent as AddTestScriptModalIcon } from 'common/assets/images/survey-outline.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import { Loader } from 'common/components/Loader/Loader';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import {
	CONTROL_TESTSCRIPT_ACTIONS_DESCRIPTION,
	CONTROL_TESTSCRIPT_ACTIONS_TYPE,
	CONTROL_TESTSCRIPT_ACTIONS_MODAL_TITLE,
} from 'common/constants/TestScriptHubControlConstants';
import { APP_GENERAL_ERROR_MSG } from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';
import { setControlStepsData } from 'common/store/reducer/controlTestScriptReducer';
import {
	downloadCsvFileData,
	getFileName,
	swapArrayItems,
} from 'common/utils/utilFunctions';

import { createSelectedControlTestSteps } from 'features/TestMonitoring/api';
import { IControlTestStepsRequestParams } from 'features/TestMonitoring/api/type-def';

import ControlTestStepActions from './ControlTestStepActions/ControlTestStepActions';
import ControlTestStepAddEditActions from './ControlTestStepAddEditActions/ControlTestStepAddEditActions';

import styles from './ControlTestScriptStepsLayout.module.scss';

interface IControlTestScriptStepsLayoutProps {
	type: string;
	controValue: string;
	generatedSteps: any;
	loading: boolean;
	isActionsEnabled?: boolean;
	deleteModal?: boolean;
	hideActions?: boolean;
}
const { DELETE_TEST_SCRIPT } = CONTROL_TESTSCRIPT_ACTIONS_DESCRIPTION;

const { ADD_TEST_SCRIPT_MODAL_TITLE, EDIT_TEST_SCRIPT_MODAL_TITLE } =
	CONTROL_TESTSCRIPT_ACTIONS_MODAL_TITLE;
const { ADD_TEST_ACTION, EDIT_TEST_ACTION, DELETE_TEST_ACTION } =
	CONTROL_TESTSCRIPT_ACTIONS_TYPE;

const ControlTestScriptStepsLayout = (
	props: IControlTestScriptStepsLayoutProps,
) => {
	const {
		type,
		controValue,
		generatedSteps,
		loading,
		isActionsEnabled,
		deleteModal,
		hideActions = false,
	} = props;
	const { checkboxSelectionColor, listHoverColor } = styles;
	const resetStepsLayout: boolean = useSelector(
		(state: RootState) => state.controlTestScript.resetTestStepsState,
	);
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const dispatch = useDispatch();
	const [openAddTestScriptModal, setAddTestScriptModal] =
		useState<boolean>(false);
	const [addTestScriptModalLabel, setAddTestScriptModalLabel] =
		useState<string>('');
	const [allStepsData, setAllStepsData] = useState<string[]>([]);
	const [testStepItemActionType, setTestStepItemActionType] =
		useState<string>('');
	const [openActionsTestScriptModal, setActionsTestScriptModal] =
		useState<boolean>(false);
	const [selectedActionItem, setSelectedActionItem] = useState<string>('');
	const [alertText, setAlertText] = useState<string>('');
	const [reviwerChecked, setReviwerChecked] = useState<boolean>(true);
	const [selectedIndex, setSelectedIndex] = useState<number>(0);
	const [stepsloading, setLoading] = useState<boolean>(loading);
	const [stepsSaveloading, setSaveLoading] = useState<boolean>(false);
	const [openAlert, setAlert] = useState<boolean>(false);
	const [toastMessage, setToastMessage] = useState<string>('');
	const [severity, setAlertSeverity] = useState<string>('');
	const [hoverAction, setHoverAction] = useState<boolean>(false);
	const [editIndex, setEditIndex] = useState<number>(0);

	const handleToast = () => {
		setAlert(false);
	};

	const { iconFillColor } = styles;

	const handleModalClose = () => {
		setAddTestScriptModal(false);
		setAddTestScriptModalLabel('');
	};

	const onAddSteps = () => {
		setAddTestScriptModal(true);
		setAddTestScriptModalLabel(ADD_TEST_SCRIPT_MODAL_TITLE);
		setTestStepItemActionType(ADD_TEST_ACTION);
		setSelectedActionItem('');
	};

	const addTestScript = (data: any) => {
		setAllStepsData((prevState: any) => {
			const prevData = [...prevState];
			prevData.push(data);
			return prevData;
		});
		dispatch(setControlStepsData(allStepsData));
		handleModalClose();
		setHoverAction(false);
	};

	const onEditTestScript = (data: string, index: number) => {
		setSelectedIndex(index);
		setEditIndex(index);
		setSelectedActionItem(data);
		setAddTestScriptModal(true);
		setAddTestScriptModalLabel(EDIT_TEST_SCRIPT_MODAL_TITLE);
		setTestStepItemActionType(EDIT_TEST_ACTION);
	};

	const editTestScript = (desc: string, index: number) => {
		if (allStepsData.length > 0) {
			const newArr = allStepsData.map((ele: string, eindex: number) => {
				const tempIndex = index === editIndex ? index : editIndex;

				if (eindex === tempIndex) {
					ele = desc;
				}
				return ele;
			});
			setAllStepsData([...newArr]);
			dispatch(setControlStepsData(newArr));
		}
		setHoverAction(false);
		handleModalClose();
	};

	const handleActionsModalClose = () => {
		onReset();
	};

	const onReset = () => {
		setActionsTestScriptModal(false);
		setAddTestScriptModal(false);
		setAddTestScriptModalLabel('');
		setSelectedActionItem('');
		setTestStepItemActionType('');
		setAlertText('');
	};
	const onDeleteTestScript = (data: string, index: number) => {
		setActionsTestScriptModal(true);
		setAddTestScriptModal(false);
		setAddTestScriptModalLabel('Delete Test Step');
		setSelectedActionItem(data);
		setSelectedIndex(index);
		setEditIndex(index);
		setTestStepItemActionType(DELETE_TEST_ACTION);
		setAlertText(DELETE_TEST_SCRIPT);
	};
	const callOnActionSelect = (index: any) => {
		if (allStepsData.length > 0) {
			const tempIndex = index === editIndex ? index : editIndex;
			const remainingSteps = allStepsData.filter(
				(x: string, i: number) => i !== tempIndex,
			);
			dispatch(setControlStepsData(remainingSteps));
			setAllStepsData((prevState: any) => {
				let prevData = [...prevState];
				prevData = prevData.filter((x: string, i: number) => i !== tempIndex);
				return prevData;
			});
		}
		onReset();
	};

	const onDragData = (e: any, data: any, index: number) => {
		setSelectedIndex(index);
	};

	const onDropData = (e: any, data: any, index: number) => {
		e.preventDefault();
		let updatedData: any;
		setAllStepsData((prevState: any) => {
			const prevData = [...prevState];
			updatedData = swapArrayItems(prevData, selectedIndex, index);
			return updatedData;
		});
		dispatch(setControlStepsData(updatedData));
		setHoverAction(false);
	};

	const onCovertJsonToCSV = (data: any) => {
		const values = data.map((ele: any, index: number) => {
			const indexVal = index + 1;
			const obj = { 'S.No': indexVal, 'Test Script Description': ele };
			return obj;
		});
		const csvFileName = getFileName();
		downloadCsvFile(values, csvFileName);
	};

	const downloadCsvFile = (data: any, fileName: string) => {
		downloadCsvFileData(data, fileName);
	};

	const onCheckBoxSelected = (e: any) => {
		setReviwerChecked(e?.target?.checked);
	};

	const onSaveTestLibrary = async () => {
		const loggedInUserId = loggedInUser?.userId || '';
		const requestParams: IControlTestStepsRequestParams = {
			testingSteps: '',
			testingStepsGeneratedBy: loggedInUserId,
			controlId: controValue,
		};
		let tempTestSteps = '';
		allStepsData.forEach((ele: string, index: number) => {
			tempTestSteps += `${index + 1}.${ele}. `;
		});
		requestParams.testingSteps = tempTestSteps;
		setSaveLoading(true);
		const response = await createSelectedControlTestSteps(requestParams);
		if (response?.statusCode === 201) {
			const alertObj = {
				message: 'Test steps saved successfully.',
				severity: 'success',
			};
			setAlertMessage(alertObj);
		} else {
			const errorAlertObj = {
				message: APP_GENERAL_ERROR_MSG,
				severity: 'error',
			};
			setAlertMessage(errorAlertObj);
		}
	};

	const setAlertMessage = (data: any) => {
		setAlert(true);
		setToastMessage(data?.message);
		setAlertSeverity(data?.severity);
		setSaveLoading(false);
	};

	useEffect(() => {
		setAllStepsData([...generatedSteps]);
	}, [generatedSteps]);

	const setListHover = (index: number) => {
		setHoverAction(true);
		setSelectedIndex(index);
	};

	const onHideListActions = () => {
		setHoverAction(false);
		setSelectedIndex(0);
	};
	const callOnDownload = useCallback(() => {
		if (allStepsData.length) {
			onCovertJsonToCSV(allStepsData);
		}
	}, [allStepsData]);

	const onSaveDisable = useCallback(() => {
		let disabled = true;

		if (stepsloading) {
			return disabled;
		}
		if (reviwerChecked && allStepsData.length !== 0) {
			disabled = false;
			return disabled;
		}

		return disabled;
	}, [reviwerChecked, stepsloading, allStepsData]);
	useEffect(() => {
		if (resetStepsLayout) {
			setAllStepsData([]);
			setReviwerChecked(false);
		}
	}, [resetStepsLayout]);
	useEffect(() => {
		setLoading(loading);
	}, [loading]);
	return (
		<Grid container item xs={12}>
			<Typography className={styles['testscript-steps-layout-main']}>
				{type}
			</Typography>

			<Grid container item xs={12} lg={12} md={12} sm={12} direction="row">
				{!stepsloading && !stepsSaveloading ? (
					<Paper
						className={
							hideActions
								? styles['testscript-steps-layout-noactions']
								: styles['testscript-steps-layout']
						}
						data-testid="steps-layout"
					>
						{allStepsData && allStepsData.length > 0 && (
							<List
								sx={{
									'& :hover': {
										backgroundColor: listHoverColor,
									},
								}}
							>
								{allStepsData.map((ele: string, index: number) => (
									<ListItem
										data-testid="steps-count"
										className={styles['testscript-steps-layout-list-item']}
										key={ele}
										onMouseOver={() => {
											setListHover(index);
										}}
										onFocus={() => {
											setListHover(index);
										}}
										onMouseOut={() => {
											onHideListActions();
										}}
										onBlur={() => {
											onHideListActions();
										}}
										onDrop={(e) => {
											onDropData(e, ele, index);
										}}
										onDragOver={(e) => e.preventDefault()}
									>
										<Grid
											container
											item
											xs={12}
											lg={12}
											md={12}
											sm={12}
											spacing={1}
											direction="row"
											alignItems="center"
										>
											<Grid item xs={12} lg={11} md={11} sm={12}>
												<ListItemText
													className={
														styles['testscript-steps-layout-desc-block']
													}
													sx={{
														'& .MuiTypography-root': {
															display: 'flex',
															flexDirection: 'row',
															alignItems: 'start',
														},
													}}
												>
													<p
														className={
															styles['testscript-steps-layout-list-item']
														}
													>
														{`${index + 1}${'.'}`}&nbsp;
													</p>
													<p
														className={
															styles['testscript-steps-layout-list-item-desc']
														}
													>
														{ele}
													</p>
												</ListItemText>
											</Grid>
											<Grid
												item
												xs={12}
												lg={1}
												md={1}
												sm={12}
												onDrop={(e) => {
													onDropData(e, ele, index);
												}}
												onDragOver={(e) => e.preventDefault()}
											>
												{hoverAction &&
												selectedIndex === index &&
												!hideActions ? (
													<ListItemIcon
														sx={{
															'& :hover': {
																cursor: 'pointer',
															},
														}}
														className={styles['testscript-menu-layout-img']}
													>
														<EditIcon
															data-testid="edit-icon"
															className={
																styles['testscripts-info-icon-actions']
															}
															onClick={() => {
																onEditTestScript(ele, index);
															}}
															fill={iconFillColor}
														/>
														<DeleteIcon
															data-testid="delete-icon"
															className={
																styles['testscripts-info-icon-actions']
															}
															onClick={() => {
																onDeleteTestScript(ele, index);
															}}
															fill={iconFillColor}
														/>
														<div
															draggable
															onDragStart={(e) => {
																onDragData(e, ele, index);
															}}
															data-testid="order-item"
														>
															<Tooltip
																title="Reorder"
																placement="right-start"
																data-testid="priority-tooltip"
																className={styles['info-icon']}
															>
																<OrderIcon
																	data-testid="order-icon"
																	className={
																		styles['testscripts-info-icon-order']
																	}
																/>
															</Tooltip>
														</div>
													</ListItemIcon>
												) : null}
											</Grid>
										</Grid>
									</ListItem>
								))}
							</List>
						)}
					</Paper>
				) : (
					<Grid
						container
						item
						xs={12}
						lg={12}
						md={12}
						sm={12}
						direction="row"
						justifyContent="center"
					>
						{' '}
						<Loader show />
					</Grid>
				)}
			</Grid>
			{!stepsloading && !isActionsEnabled && (
				<Grid
					container
					item
					xs={12}
					lg={12}
					md={12}
					sm={12}
					direction="row"
					mt={3}
				>
					<Grid
						item
						xs={12}
						lg={6}
						md={6}
						sm={12}
						className={styles['testscript-steps-layout-btns']}
					>
						<Checkbox
							size="small"
							role="checkbox"
							data-testid="checkbox-selection"
							onChange={onCheckBoxSelected}
							checked={reviwerChecked}
							inputProps={{ className: 'selectCheckbox' }}
							sx={{
								'& :hover': { background: 'none' },
								paddingRight: '0px',
								paddingLeft: '0px',
								[`&, &.${checkboxClasses.checked}`]: {
									color: checkboxSelectionColor,
								},
							}}
						/>
						<Typography
							className={styles['testscript-steps-layout-reviewer-text']}
						>
							Test Steps have been approved by Reviewer
						</Typography>
					</Grid>
					<Grid
						item
						xs={12}
						lg={6}
						md={6}
						sm={12}
						className={styles['testscript-steps-layout-btn-grp']}
						spacing={2}
					>
						<ButtonComp
							btnType="secondary"
							clickHandler={callOnDownload}
							disabled={allStepsData.length === 0}
							data-testid="download-steps"
						>
							Download work sheet
						</ButtonComp>
						<ButtonComp
							btnType="secondary"
							clickHandler={onAddSteps}
							data-testid="add-steps"
						>
							Add step
						</ButtonComp>
						<ButtonComp
							btnType="primary"
							clickHandler={onSaveTestLibrary}
							disabled={onSaveDisable()}
							data-testid="save-steps"
						>
							Save to test script library
						</ButtonComp>
					</Grid>
				</Grid>
			)}

			{openAddTestScriptModal && (
				<ControlTestStepAddEditActions
					openModal={openAddTestScriptModal}
					title={addTestScriptModalLabel}
					handleClose={handleModalClose}
					addTestScript={addTestScript}
					ModalHeaderImg={
						testStepItemActionType === ADD_TEST_ACTION
							? AddTestScriptModalIcon
							: EditTestScriptModalIcon
					}
					testScriptData={selectedActionItem}
					editTestScript={editTestScript}
					type={testStepItemActionType}
					rowIndex={selectedIndex}
				/>
			)}

			{openActionsTestScriptModal && (
				<ControlTestStepActions
					openModal={openActionsTestScriptModal}
					title={addTestScriptModalLabel}
					handleClose={handleActionsModalClose}
					handleAction={callOnActionSelect}
					ModalHeaderImg={
						testStepItemActionType === DELETE_TEST_ACTION
							? DeleteTestScriptModalIcon
							: null
					}
					type={testStepItemActionType}
					alertText={alertText}
					testScriptData={selectedActionItem}
					rowIndex={selectedIndex}
				/>
			)}
			{deleteModal && (
				<ControlTestStepActions
					openModal={openActionsTestScriptModal}
					title="Confirm delete"
					handleClose={handleActionsModalClose}
					handleAction={callOnActionSelect}
					ModalHeaderImg={null}
					type={testStepItemActionType}
					alertText="This action cannot be undone and you will not be able to recover this Job Data."
					testScriptData={selectedActionItem}
					rowIndex={selectedIndex}
				/>
			)}

			<AlertComponent
				open={openAlert}
				toastMessage={toastMessage}
				severity={severity}
				handleCloseMessage={handleToast}
				vertical="top"
				horizontal="center"
			/>
		</Grid>
	);
};

export default ControlTestScriptStepsLayout;
